import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseKsefNumberAlreadyInUseError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.ksef-number.already-in-use');
    }
}
